import './IconButton.css'
import React from 'react'
import classNames from 'classnames'
import { Tooltip } from 'antd'

type Props = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "submit" | "reset" | "button";
  className?: string;
  children?: React.ReactNode;
  tooltip?: string;
}

export default function IconButton({ onClick, type, className, children, tooltip }: Props) {
  return (
    <Tooltip title={tooltip}>
      <button
        onClick={onClick}
        type={type}
        className={
          classNames([
            'icon-button',
            className
          ])
        }>{children}</button>
    </Tooltip>
  )
}
